/* <machines-megamenu> — Direction B two-pane behaviour.
   Rail brand buttons reveal the matching pane on hover, keyboard focus, or
   click. Everything is server-rendered; this only toggles which pane shows, so
   with JS off the panel still works (CSS stacks every pane). */
class MachinesMegamenu extends HTMLElement {
  connectedCallback() {
    this.brands = Array.from(this.querySelectorAll('[data-mm-brand]'));
    this.panes = Array.from(this.querySelectorAll('[data-mm-pane]'));
    if (!this.brands.length) return;

    this.brands.forEach((btn) => {
      const select = () => this.activate(btn.dataset.mmBrand);
      btn.addEventListener('mouseenter', select);
      btn.addEventListener('focus', select);
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        select();
      });
    });
  }

  activate(index) {
    this.brands.forEach((btn) => {
      const on = btn.dataset.mmBrand === index;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    this.panes.forEach((pane) => {
      pane.hidden = pane.dataset.mmPane !== index;
    });
  }
}

if (!customElements.get('machines-megamenu')) {
  customElements.define('machines-megamenu', MachinesMegamenu);
}
